"use strict";
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import _ from "underscore";
import classNames from "classnames";
import { escapeRegExp } from "../../util/strings";
const PageTextHighlighter = React.createClass({
  getInitialState: function() {
    return {
      escapedTextToHighlight: escapeRegExp(this.props.textToHighlight)
    };
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      escapedTextToHighlight: escapeRegExp(nextProps.textToHighlight)
    });
  },
  componentDidUpdate: function(prevProps) {
    if (this.props.lines !== prevProps.lines) {
      this.enableDragAndDrop();
    }
  },
  shouldHighlight: function(line) {
    if (!this.state.escapedTextToHighlight) {
      return false;
    }
    return line.chars.match(this.state.escapedTextToHighlight);
  },
  componentDidMount: function() {
    this.enableDragAndDrop();
  },
  componentWillUnmount: function() {
    this.disableDragAndDrop();
  },
  enableDragAndDrop: function() {
    $(this.container()).find(".o-t").draggable({
      cursor: "move",
      revert: "invalid",
      scope: "dnd-text",
      zIndex: 100,
      appendTo: "body",
      helper: this.cloneElement
    });
  },
  cloneElement: function(e) {
    const clone = e.target.cloneNode();
    clone.removeAttribute("data-reactid");
    return clone;
  },
  disableDragAndDrop: function() {
    $(this.container()).find(".ui-draggable").draggable("destroy");
  },
  textLine: function(line, index) {
    const className = classNames({
      "o-t": true,
      "o-h": this.shouldHighlight(line)
    });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: this.styleForLine(line),
        "data-chars": line.chars,
        "data-top": line.top,
        "data-left": line.left,
        "data-width": line.width,
        "data-height": line.height,
        key: "text_line_" + index,
        className
      },
      "\xA0"
    );
  },
  styleForLine: function(line) {
    return {
      top: line.top * (this.props.imageHeight || 0),
      left: line.left * (this.props.imageWidth || 0),
      width: line.width * (this.props.imageWidth || 0) + 2,
      height: line.height * (this.props.imageHeight || 0) + 2
    };
  },
  container: function() {
    return ReactDOM.findDOMNode(this.refs.container);
  },
  render: function() {
    const classes = classNames({
      "ocred-document__wrapper": true,
      "ocred-document__wrapper--enabled": true
    });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "PageTextHighlighter",
        className: classes,
        ref: "container"
      },
      _.map(this.props.lines, this.textLine)
    );
  }
});
export default PageTextHighlighter;
